import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SearchStrategyService } from '@services/search-strategy.service';
import { LookupService } from '@services/lookup.service';
import { LoggingService } from '@services/logging.service';
import { FilterService } from '@services/filter.service';
import { StudySearchStrategy } from '@models/searchStrategy.model';
import { StudySearchFilter } from '@models/studySearchFilter.model';
import { AccountTypesCriteria } from './filter-account-types.model';
import { TreeNode } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as Constants from '@shared/_constants';
import { ControlContainer, NgForm } from '@angular/forms';
import { FilterUtilService } from '../shared/filter-util.service';

@Component({
  selector: 'app-filter-account-types',
  templateUrl: './filter-account-types.component.html',
  styleUrls: ['./filter-account-types.component.css'],
  providers: [SearchStrategyService],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FilterAccountTypesComponent implements OnInit, OnDestroy {
  @Input() filter: any;
  @Input() readOnly = false;

  accountTypes: TreeNode[] = [];
  formDirty = false;
  searchStrategy: StudySearchStrategy;
  strategy: StudySearchFilter;
  showLoader = false;

  private destroy$ = new Subject();

  constructor(
    private lookupService: LookupService,
    private logger: LoggingService,
    private searchStrategyService: SearchStrategyService,
    private filterService: FilterService,
    private filterUtil: FilterUtilService
  ) {}

  async ngOnInit() {
    this.loadInitialData();
  }

  initializeForm() {
    // if (this.filter != null) {
    // }
    this.filter.accountTypeSelection = this.accountTypes.filter((selection) =>
      this.filterUtil.findNodeRecursive(selection.data, (<AccountTypesCriteria>this.filter).accountTypeSelection)
    );
  }

  loadInitialData() {
    this.logger.info(this.constructor.name, Constants.LoggerMessages.LOGGER_NGONINIT, Constants.LoggerMessages.LOGGER_START);
    this.searchStrategy = this.searchStrategyService.studySearchStrategy;

    this.filterUtil.spinnerRS.next(true);
    this.filterService
      .getAccountTypes$(this.readOnly, this.searchStrategy.studySearchStrategyId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((_accountTypes) => {
        this.accountTypes = _accountTypes;
        this.initializeForm();
        this.filterUtil.spinnerRS.next(false);
      });
  }

  public sortSelection(selection: TreeNode[]): void {
    return this.filterUtil.sortSelection(selection);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
